import { Component, OnInit, ViewChild } from '@angular/core';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { ActivatedRoute } from '@angular/router';
import { AccountService } from '../../services/account.service';
import { CustomerNewFeaturesDto, GetAccountDetailsDto, MarkNewFeatureReadDto, UpdateAccountDetailsDto } from '../../models/account/account.models';
import { ValidateComponent } from '../../components/common/validateComponent/validate.component';
import { LoggedInUser, LoggedInUserService } from '../../auth/logged.in.user';
import { Address } from '../../models/common/address';
import {RouterService} from '../../services/routerService';
import { CmsDialogService } from '../../services/cms.dialog.service';
import { CmsDialogDto } from '../../models/cms.dialogs/cms.dialogs.models';
import { PaidFeatureUpsellService } from '../../services/paid.feature.upsell.service';

@Component({
    selector: 'view-account',
    template: require('./view.account.component.html'),
    styles: [require('./view.account.component.css')]
})
export class ViewAccountComponent extends ValidateComponent implements OnInit {

    @ViewChild('validateForm', { static: false }) currentForm;

    activeTab = 'details';
    private readonly user: LoggedInUser;
    subscribed: boolean;
    teamMember: boolean;
    dialogName: string;
    dialogHeader: string;
    dialogBody: string;
    newFeatures: Array<CustomerNewFeaturesDto>;
    showNewIcon: boolean;

    hasSubscriptions = true;

    onHasSubscriptionsChange(value: boolean) {
        this.hasSubscriptions = value;
    }

    constructor(private readonly accountService: AccountService, userService: LoggedInUserService, private readonly routerService: RouterService,
        private route: ActivatedRoute,
        private readonly cmsDialogService: CmsDialogService,
        private readonly paidFeatureUpsellService: PaidFeatureUpsellService) {
        super();

        this.user = userService.getCurrentUser();
        this.subscribed = !this.user.canAdHoc('notSubscribed');
        this.teamMember = this.user.role != 'Supplier';

        this.showNewIcon = false;

        this.accountService.getNewFeatures().subscribe((result: any) => {
            this.newFeatures = result.value;
        });
    }

    ngOnInit() {
        this.route.queryParams.subscribe(params => {
            const tab = (params && (params as any).tab ? (params as any).tab : '').toString();
            const allowed = ['details', 'subscriptions', 'prefs', 'profile', 'team', 'extraAlerts'];
            if (allowed.indexOf(tab) > -1) {
                this.activeTab = tab;
            } else {
                this.activeTab = 'details';
            }
        });
        if (this.subscribed) {
            this.dialogName = 'View Account Info - Subscribed';
        }
        else {
            this.dialogName = 'View Account Info - Not Subscribed';
        }

        this.cmsDialogService.getByDescription(this.dialogName).subscribe((result: CmsDialogDto) => {
            this.dialogHeader = result.header;
            this.dialogBody = result.body;
        });
    }

    ngOnDestroy() {
        $('#view-account-info-modal').modal('hide');
    }

    showPaidFeatureUpsellModal() {
        this.paidFeatureUpsellService.openDefault();
    }

    showInfoDialog() {
        $('#view-account-info-modal').modal();
    }

    //showNew(id: number): boolean {
    //    if (this.newFeatures == null) {
    //        this.showNewIcon = false;
    //        return false;
    //    }

    //    if (this.newFeatures.some(e => e.newFeatureId === id && !e.alreadySeen)) {
    //        this.showNewIcon = true;
    //        return true;
    //    }
    //    else {
    //        this.showNewIcon = false;
    //        return false;
    //    }
    //}

    showNew(id: number): boolean {
        if (this.newFeatures == null || this.newFeatures == undefined) {
            this.showNewIcon = false;
            return false;
        }

        if (this.newFeatures.some(e => e.newFeatureId === id && !e.alreadySeen)) {
            this.showNewIcon = true;
            return true;
        }
        else {
            this.showNewIcon = false;
            return false;
        }
    }

    markRead(id: number) {
        var dto = new MarkNewFeatureReadDto();
        dto.newFeatureId = id;
        this.accountService.markNewFeatureRead(dto);

        this.accountService.markNewFeatureRead(dto).subscribe(() => {
            console.log('success');
        }, () => {
            console.log('fail');
        });
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Client/app/views/account.management/view.account.component.ts